import { render, staticRenderFns } from "./Bahn1FeedbackBanner.vue?vue&type=template&id=8508a10c&scoped=true&"
import script from "./Bahn1FeedbackBanner.vue?vue&type=script&lang=js&"
export * from "./Bahn1FeedbackBanner.vue?vue&type=script&lang=js&"
import style0 from "./Bahn1FeedbackBanner.vue?vue&type=style&index=0&id=8508a10c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8508a10c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
